module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "light": "",
      "id": "gungho",
      "data-session-id": this.$session.get('sessionToken')
    }
  }, [_c('header-menu'), _vm._v(" "), _c('v-content', [_c('div', {
    staticClass: "progress-wrapper"
  }, [(_vm.loading) ? _c('v-progress-linear', {
    staticClass: "mt-0",
    attrs: {
      "indeterminate": true,
      "color": "blue"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-flex', {
    staticClass: "gungho-content",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": "",
      "xl10": "",
      "offset-xl1": ""
    }
  }, [_c('router-view', {
    key: _vm.$router.fullPath
  })], 1)], 1)], 1), _vm._v(" "), _c('footer-menu')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-768bcfb8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 805
// module chunks = 1